import { useQuery } from '@tanstack/react-query';
import { Badge } from '@/components/ui/badge';
import { settingsApi } from '@/lib/api/endpoints';
import { fmtRelative } from '@/lib/format';

/**
 * Agentes que este ambiente criou no provedor. Um genérico por script/idioma, mais um por
 * marca com base de conhecimento — nomeados para serem reconhecidos no painel do Retell.
 */
export function ProviderAgentsList() {
  const q = useQuery({ queryKey: ['settings', 'agents'], queryFn: settingsApi.agents });
  const agents = q.data ?? [];
  return (
    <div className="space-y-1.5 text-xs text-muted-foreground">
      <p>
        Agentes no provedor:{' '}
        {agents.length ? (
          <Badge variant="secondary">{agents.length}</Badge>
        ) : (
          <Badge variant="outline">nenhum — o primeiro nasce na 1ª ligação</Badge>
        )}
      </p>
      {agents.length > 0 && (
        <ul className="space-y-1">
          {agents.map((a) => (
            <li key={a.id} className="flex flex-wrap items-baseline gap-x-2">
              <span className="font-medium text-foreground">{a.name}</span>
              <code className="text-[11px]">{a.agentId}</code>
              <span>· {fmtRelative(a.updatedAt)}</span>
            </li>
          ))}
        </ul>
      )}
      <p>
        Um agente atende todas as marcas sem base de conhecimento; cada marca com base ganha o seu.
        O sistema cria e atualiza sozinho — não edite no painel do Retell.
      </p>
    </div>
  );
}
